import Ext from 'Ext'
import PickerMenu from './at_picker_menu'
import WeekPicker from './at_week_picker'
Ext.namespace('AT.menu');

const WeekPickerMenu = Ext.extend(PickerMenu, {

    constructor : function(config)
    {
        const picker = new WeekPicker( config );
        WeekPickerMenu.superclass.constructor.call(this, config, picker);
    }});

Ext.extend(WeekPickerMenu, PickerMenu);

export default WeekPickerMenu



// WEBPACK FOOTER //
// ./web/js/controls/dateControls/at_week_picker_menu.js